module.exports = "<div class=\"container\">\n  <router-outlet></router-outlet>\n  <app-footer></app-footer>\n</div>\n"